import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from 'cbc-shared-lib';

import { FeaturesLibConfig } from './config/features-lib-config';
import { FEATURES_LIB_CONFIG } from './config/features-lib-config.token';

/**
 * 共通モジュール
 * @export
 * @class FeaturesModule
 */
@NgModule({
  declarations: [
  ],
  imports: [
  ],
  exports: [
  ]
})
export class FeaturesModule {
  public static forRoot(featuresLibConfig: FeaturesLibConfig): ModuleWithProviders<FeaturesModule> {
    console.log("call features forRoot");
    return {
        ngModule: FeaturesModule,
        providers: [
          { provide: FEATURES_LIB_CONFIG, useValue: featuresLibConfig}
        ]
    };
  }
}
